module.exports = __webpack_public_path__ + "static/img/陈瑾.a68ff23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/陈瑾.jpg
// module id = jNgL
// module chunks = 1